import { useConsent } from 'hooks/useConsent'
import { Link } from 'react-router-dom'

const PrivacyConsentCheckbox = () => {
  const [consent, setConsent] = useConsent()

  return (
    <div className='flex justify-center items-center space-x-2 mt-8'>
      <input
        type='checkbox'
        id='privacy-consent'
        name='privacy-consent'
        checked={consent !== 'ask'}
        onChange={() => setConsent(consent !== 'ask' ? 'ask' : 'given')}
        className='w-4 h-4 bg-[#B8E0DB] checked:bg-[#0C5F71] rounded-sm shadow-inner-md border-0'
      />
      <label htmlFor='privacy-consent' className='text-xs lg:text-sm'>
        I agree to the{' '}
        <Link
          to='/terms-and-policies/terms-of-use-consumer'
          className='text-[#001A3D] font-medium underline'
        >
          Terms of Use
        </Link>{' '}
        and{' '}
        <Link
          to='terms-and-policies/data-protection-policy'
          className='text-[#001A3D] font-medium underline'
        >
          Privacy Policy
        </Link>
      </label>
    </div>
  )
}

export default PrivacyConsentCheckbox
